const vebBenefitTypes = ["PRIMARY", "CONTINGENT"];

export const VEB_BENEFIT_TYPES = vebBenefitTypes;
